import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import flowRight from 'lodash/flowRight';
import { actions as cardSuggestActions } from '@ott/shared-credit-cards-logic';
import validateCard from './validation/validate';
import { asyncValidate } from './validation/asyncValidate';
import CreditCard from '../component';
import { payCardSelector } from './selector';

const CreditCardWrapper = (props) => (
  <form>
    <CreditCard {...props} />
  </form>
);

export const PAY_FORM = 'PayForm';

const reduxFormConfig = {
  form: PAY_FORM,
  initialValues: {
    saveCard: true,
  },
  shouldValidate: (params) => {
    const {
      values,
      nextProps,
      props,
      initialRender,
      lastFieldValidatorKeys,
      fieldValidatorKeys,
      structure,
    } = params;

    if (initialRender) {
      return true;
    }

    if (props.isInactive !== nextProps.isInactive) {
      return true;
    }

    return (
      !structure.deepEqual(values, nextProps.values) ||
      !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys) ||
      props.registeredFields !== nextProps.registeredFields
    );
  },
  validate: (values, props) => {
    if (props.isInactive) {
      return {};
    }

    return { ...validateCard(values, props) };
  },
  asyncValidate,
};

const { getSuggests, updateActive, resetSuggest, removeCard } = cardSuggestActions;

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSuggests,
      updateActive,
      resetSuggest,
      removeCard,
    },
    dispatch
  );

export default flowRight(
  reduxForm(reduxFormConfig),
  connect(payCardSelector, mapDispatchToProps)
)(CreditCardWrapper);
